import React from "react";

interface IPanelContent {
  contentCssClass?: string
  measureRef?: React.LegacyRef<HTMLDivElement>
}

class PanelContent extends React.PureComponent<React.PropsWithChildren<IPanelContent>> {
  public render(): JSX.Element {
    const { contentCssClass, measureRef } = this.props;

    return (
      <div ref={measureRef} className={contentCssClass}>
        {this.props.children}
      </div>
    );
  }
}

export default PanelContent;
